import request from '@/utils/request'

// 获取账户列表
export const getGcashAccountList = (params: any) =>
  request({
    url: '/manage/gcashpay-account',
    method: 'get',
    params
  })

// 获取单个账户
export const getGcashAccount = (params: any) =>
  request({
    url: '/manage/gcash-account/' + params.id,
    method: 'get'
  })

// 创建账户
export const addGcashAccount = (data: any) =>
  request({
    url: '/manage/gcash-account',
    method: 'post',
    data
  })

// 更改单个账户
export const editGcashAccount = (data: any) =>
  request({
    url: '/manage/gcashpay-account/' + data.id,
    method: 'patch',
    data
  })

// 更改多个账户
export const editMultipleGcashAccount = (data: any) =>
  request({
    url: '/manage/gcash-account/update',
    method: 'put',
    data
  })

// 删除单个账户
export const delGcashAccount = (data: any) =>
  request({
    url: '/manage/gcashpay-account/' + data.id,
    method: 'delete',
    data
  })

// 删除多个账户
export const delGcashMultipleAccount = (params: any) =>
  request({
    url: '/manage/gcash-account/delete',
    method: 'delete',
    params
  })

// 日志
export const getLogList = (params: any) =>
  request({
    url: '/manage/gcash/pay/record',
    method: 'get',
    params
  })

// 操作日志
export const getActionLog = (params: any) =>
  request({
    url: `/manage/gcashpay-log`,
    method: 'get',
    params
  })

// 事件接口
export const setConnectivityTest = (data: any) =>
  request({
    url: '/manage/gcash/handle/action',
    method: 'post',
    data
  })

// 转账
export const setPay = (data: any) =>
  request({
    url: '/manage/gcash/pay/action',
    method: 'post',
    data
  })

// 转账
export const setInviteLogin = (data: any) =>
  request({
    url: '/manage/gcashpay-api',
    method: 'post',
    data
  })

// 账单
export const getBillList = (params: any) =>
  request({
    url: '/manage/gcashpay-Bill',
    method: 'get',
    params
  })
